// extracted by mini-css-extract-plugin
export default {"primary":"button_primary__q9Ok1","button":"button_button__nHBEj","outline":"button_outline__JuuXw"};